// Storage keys
export const STORAGE_KEYS = {
  PREFERRED_ORG_ID: 'preferred_organization_id',
  IG_SETUP_BOT_ID: 'ig_setup_bot_id',
  IG_EXTERNAL_BOT_ID: 'ig_external_bot_id',
  IG_EXTERNAL_TOKEN: 'ig_external_token',
  FB_EXTERNAL_BOT_ID: 'fb_external_bot_id',
  FB_EXTERNAL_TOKEN: 'fb_external_token',
} as const;

// Local Storage
export const storageLocal = {
  getPreferredOrgId: (): string | null => window.localStorage.getItem(STORAGE_KEYS.PREFERRED_ORG_ID),
  setPreferredOrgId: (orgId: string): void => {
    window.localStorage.setItem(STORAGE_KEYS.PREFERRED_ORG_ID, orgId);
  },
  // The bot id now travels in the OAuth state; this only clears the key older sessions left.
  clearIgSetupBotId: (): void => {
    window.localStorage.removeItem(STORAGE_KEYS.IG_SETUP_BOT_ID);
  },
  getIgExternalBotId: (): string | null => (
    window.sessionStorage.getItem(STORAGE_KEYS.IG_EXTERNAL_BOT_ID)
  ),
  setIgExternalBotId: (botId: string): void => {
    window.sessionStorage.setItem(STORAGE_KEYS.IG_EXTERNAL_BOT_ID, botId);
  },
  getIgExternalToken: (): string | null => (
    window.sessionStorage.getItem(STORAGE_KEYS.IG_EXTERNAL_TOKEN)
  ),
  setIgExternalToken: (token: string): void => {
    window.sessionStorage.setItem(STORAGE_KEYS.IG_EXTERNAL_TOKEN, token);
  },
  clearIgExternal: (): void => {
    window.sessionStorage.removeItem(STORAGE_KEYS.IG_EXTERNAL_BOT_ID);
    window.sessionStorage.removeItem(STORAGE_KEYS.IG_EXTERNAL_TOKEN);
  },
  getFbExternalBotId: (): string | null => (
    window.sessionStorage.getItem(STORAGE_KEYS.FB_EXTERNAL_BOT_ID)
  ),
  setFbExternalBotId: (botId: string): void => {
    window.sessionStorage.setItem(STORAGE_KEYS.FB_EXTERNAL_BOT_ID, botId);
  },
  getFbExternalToken: (): string | null => (
    window.sessionStorage.getItem(STORAGE_KEYS.FB_EXTERNAL_TOKEN)
  ),
  setFbExternalToken: (token: string): void => {
    window.sessionStorage.setItem(STORAGE_KEYS.FB_EXTERNAL_TOKEN, token);
  },
  clearFbExternal: (): void => {
    window.sessionStorage.removeItem(STORAGE_KEYS.FB_EXTERNAL_BOT_ID);
    window.sessionStorage.removeItem(STORAGE_KEYS.FB_EXTERNAL_TOKEN);
  },
  clearAll: (): void => {
    window.localStorage.removeItem(STORAGE_KEYS.PREFERRED_ORG_ID);
    window.localStorage.removeItem(STORAGE_KEYS.IG_SETUP_BOT_ID);
    window.sessionStorage.removeItem(STORAGE_KEYS.IG_EXTERNAL_BOT_ID);
    window.sessionStorage.removeItem(STORAGE_KEYS.IG_EXTERNAL_TOKEN);
    window.sessionStorage.removeItem(STORAGE_KEYS.FB_EXTERNAL_BOT_ID);
    window.sessionStorage.removeItem(STORAGE_KEYS.FB_EXTERNAL_TOKEN);
    // Legacy keys cleanup
    window.localStorage.removeItem('currentBot');
    window.localStorage.removeItem('currentOrganization');
  },
};
